module.exports = __webpack_public_path__ + "img/reference52.ae326491.jpg";